<nav class="back-to-navigation show-for-medium-down" [ngClass]="position">
  <div class="grid-container">
    <div class="grid-x">
      <div class="cell flex-container align-middle">
        <a class="button button--icon-on-left small clear" routerLink={{linkTo}}
          data-test="mono-common-back-to-navigation-bar-link">
          <svg class="icon icon--arrow-left" viewBox="0 0 24 24" style="width: 21px; height: 21px">
            <use xlink:href="#icon-arrow-left" href="#icon-arrow-left"></use>
          </svg>
          <span><span ></span><span data-test="mono-common-back-to-navigation-bar-link-text"><strong>{{linkText}}</strong></span></span></a>
      </div>
    </div>
  </div>
</nav>
